var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.338,
    height: 19.213,
    viewBox: "0 0 22.338 19.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style_linear",
    "data-name": "style=linear",
    transform: "translate(-1.25 -2.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(2 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M17.629,21.213H7.21C4.084,21.213,2,19.65,2,16V8.71C2,5.063,4.084,3.5,7.21,3.5H17.629c3.126,0,5.21,1.563,5.21,5.21V16C22.838,19.65,20.754,21.213,17.629,21.213Z",
    transform: "translate(-2 -3.5)",
    fill: "none",
    stroke: "#002147",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M19.337,7.769l-5.779,4.466a2.084,2.084,0,0,1-2.548,0L5.23,7.769",
    transform: "translate(-1.865 -4.321)",
    fill: "none",
    stroke: "#002147",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.cba7cfc7e307a2f6638bc73c11a45a2c.svg";
export { ForwardRef as ReactComponent };